import React, { useEffect, useState } from "react";
// import { get_direction1 } from "../api_services/get_direction1";
import { StartStop } from "./StartStop";
import { DefineAmount } from "./DefineAmount";
import { TrendTracker } from "./TrendTracker";
import { DefineTakeProfit } from "./DefineTakeProfit";
import { get_direction } from "../api_services/get_direction";

export const Dashboard = () => {
    const [directions, setDirections] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await get_direction();
                console.log(response);
                setDirections(Array.isArray(response) ? response : []);
            } catch (error) {
                console.error("Failed to fetch directions:", error);
            }
            setTimeout(fetchData, 1000);
        };

        fetchData();
    }, []);

    return (
        <div className="min-h-screen bg-gradient-to-r from-[#010057] via-[#010057] to-[#010057] p-6">
            <div className="max-w-6xl mx-auto">
                <h1 className="text-3xl font-bold text-center text-white mb-6">📊KELVIN TICK DIRECTION</h1>

                <div className="flex flex-wrap justify-center gap-6 mb-6">
                    <StartStop />
                    <DefineAmount />
                    <TrendTracker />
                    {/*<DefineTakeProfit />*/}
                </div>

                <div className="bg-[#02006c] rounded-xl shadow overflow-x-auto">
                    <table className="min-w-full text-sm text-left">
                        <thead className="bg-gray-200 text-gray-700">
                            <tr>
                                <th className="px-4 py-2">Symbol</th>
                                <th className="px-4 py-2">Start Time</th>
                                <th className="px-4 py-2">Start Price</th>
                                <th className="px-4 py-2">Current Price</th>
                                <th className="px-4 py-2">Direction</th>
                            </tr>
                        </thead>
                        <tbody>
                            {directions.map((dir) => (
                                <tr key={dir.id} className="border-b last:border-none hover:bg-blue-500 transition">
                                    <td className="px-4 py-2 text-white font-medium">{dir.symbol}</td>
                                    <td className="px-4 py-2 text-white">{new Date(dir.candle_start_time).toLocaleString()}</td>
                                    <td className="px-4 py-2 text-white font-semibold">{parseFloat(dir.first_price).toFixed(5)}</td>
                                    <td className="px-4 py-2 text-white font-semibold">{parseFloat(dir.price).toFixed(5)}</td>
                                    <td className={`px-4 py-2 font-bold ${dir.direction === "UP" ? "text-green-500" : "text-red-500"}`}>
                                        {dir.direction}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};
